import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper';
import AtomicButton from '../../atomic/button/Button';
import InputBox from '../../atomic/inputbox/InputBox';
import SelectBox from '../../atomic/selectbox/SelectBox';
import GoogleAddressInput from '../googleaddressinput/GoogleAddressInput';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import {TimePicker from "@mui/x-date-pickers/TimePicker";
import {
  isValidEmail,
  isValidZipcodeFormat,
  isValidAptNo,
  isAlphanumericHyphenOnly,
  isFullName,
  isMobileNo,
  isPassword,
} from '../../utils/regexValidation';
import { AddressDataContext } from '../../context-api/data-provider/GoogleAddressDataProvider';
import { SignUpDataContext } from '../../context-api/data-provider/SignupDataProvider';
import { FutureCustomerContext } from '../../context-api/data-provider/FutureCustomerDataProvider';
import TimePickerInput from '../../atomic/timepicketinput/TimePickerInput';
import moment from 'moment';
import dayjs from 'dayjs';
import { Alert, AlertTitle } from '@mui/material';
import AtomicCheckbox from '../../atomic/checkbox/Checkbox';
import responseErrorMapping from '../../utils/error.response.mapping';
import { API_NETWORK_ERROR } from './../../utils/constants';
import { Error404 } from '../error404/Error404';
import ThankYouSignup from './../thankyou-signup/ThankYouSignup';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import PhoneVerifyOtp from '../../pages/phoneverify-page/PhoneVerifyOtp-Page';
import { useNativeNotificationFields } from '../../utils/reactNativeBridge';

const Signup = () => {
  const navigate = useNavigate();
  const { googleAddress } = useContext(AddressDataContext);
  const { selectedPricePLan, onPhoneVerifyResponse } = useContext(GlobalStateDataContext);
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const RedirectToPrivacy = () => navigate('/privacypolicy');
  const RedirectMerchantTerms = () => navigate('/merchanttermsofservice');

  const { signupAPIResponse, onSignUp, servingZipcodeAPIResponse } = useContext(SignUpDataContext);

  const { futureCustomerAPIResponse, setFutureCustomerAPIResponse, onFutureCustomer } =
    useContext(FutureCustomerContext);
  const [validationErrors, setValidationErrors] = useState(null);
  const bizOptions = ['Cloud kitchen', 'Restaurant', 'Home chef', 'Catering'];
  const cuisineOptions = [
    // 'Indian',
    // 'Mexican',
    // 'American chinese',
    // 'Italian',
    // 'Lebanese',
    // 'Turkish',
    // 'Fast food',
    // 'Chinese',
    // 'Mix of all',
    'American',
    'Mexican',
    'Latin American',
    'Caribbean',
    'Italian',
    'French',
    'Spanish',
    'Greek',
    'Mediterranean',
    'Middle Eastern',
    'Turkish',
    'Persian',
    'Afghan',
    'Indian',
    'Pakistani',
    'Bangladeshi',
    'Nepali',
    'Chinese',
    'Japanese',
    'Korean',
    'Thai',
    'Vietnamese',
    'Filipino',
    'Hawaiian',
    'African',
    'Ethiopian',
    'Polish',
    'Southern / Soul Food',
    'Cajun / Creole',
    'Fusion',
    'Multi-Cuisine',
    'Mix of all',
  ];
  const bizRestaurantCategory = [
    'Full-Service Restaurant',
    'Fast Food',
    'Pizza',
    'Burgers',
    'Chicken & Wings',
    'Sandwiches & Subs',
    'Kebab & Shawarma',
    'Tacos & Burritos',
    'BBQ & Grill',
    'Seafood',
    'Steakhouse',
    'Sushi',
    'Noodles & Ramen',
    'Breakfast & Brunch',
    'Healthy & Salads',
    'Coffee & Tea',
    'Bubble Tea',
    'Juice & Smoothies',
    'Bakery',
    'Pastry & Cakes',
    'Desserts & Ice Cream',
    'Street Food & Snacks',
    'Fine Dining',
    'Catering',
    'Meal Prep',
    'Grill House',
  ];
  const address = (googleAddress.description || '').replaceAll(',', '');
  const [formValues, setFormValues] = useState({
    bizType: 'Restaurant',
    cuisineType: 'Indian',
    bizCategory: 'Select',
  });
  const {
    email,
    branchName,
    phoneNo,
    bizType,
    firstName,
    lastName,
    password,
    reTypePassword,
    operation_start_time,
    operation_end_time,
    referralNo,
    cuisineType,
    bizCategory,
  } = formValues;
  const [checked, setChecked] = useState(false);
  const [smsChecked, setSmsChecked] = useState(false);
  const { data, loading, message, success } = signupAPIResponse;
  const [backendValidationError, setBackendValidationError] = useState(false);
  const [openOTPcomponent, setOpenOTPcomponent] = useState(false);
  const [notServingLocation, setNotServingLocation] = useState(false);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const regionalBranchName = servingZipcodeAPIResponse?.data?.data?.managing_branch_name;
  const nativeNotificationFields = useNativeNotificationFields();

  const ReferralValidNo = ['4088540221', '0221'];
  const ValidServingCity = servingZipcodeAPIResponse?.data?.data?.geolocation?.city;

  const isOtpVerified = !!(
    onPhoneVerifyResponse?.data?.data?.success &&
    onPhoneVerifyResponse?.data?.data?.CustomMessage == 'OTP Verified'
  );

  useEffect(() => {
    setBackendValidationError(false);
    setOpenOTPcomponent(false);
    setNotServingLocation(false);
    if (success === false && message === 'Backend Validation errors') {
      setBackendValidationError(true);
    }

    if (success && message === 'Successfully created new kitchen') {
      setOpenOTPcomponent(true);
    }
    if (success === false && message === 'Sorry we do not serve in your area') {
      setNotServingLocation(true);
    }
  }, [data]);

  const onChangeHandler = (key) => (value, timepickerContext) => {
    if (key === 'bizType') {
      setFormValues({ ...formValues, [key]: value });
      return;
    }

    if (key === 'cuisineType') {
      setFormValues({ ...formValues, [key]: value });
      return;
    }

    if (key === 'bizCategory') {
      setFormValues({ ...formValues, [key]: value });
      return;
    }

    if (key === 'operation_start_time' || key === 'operation_end_time') {
      if (key === 'operation_start_time') {
        setStartTime(value); // unformated value neede for timepicker component
      } else {
        setEndTime(value); // unformated value neede for timepicker component
      }

      setFormValues({ ...formValues, [key]: value.format('hh:mm A') });
      return;
    }

    value.preventDefault();
    const val = value.target.value;

    if (key === 'phoneNo') {
      if (val?.length <= 10) setFormValues({ ...formValues, [key]: val });
      return;
    }

    if (key === 'branchName') {
      const filtered = val.replace(/[^A-Za-z0-9-]/g, '');
      setFormValues({ ...formValues, [key]: filtered });
      return;
    }

    setFormValues({ ...formValues, [key]: val });
  };

  const handleClick = () => {
    setChecked(!checked);
  };

  const handleSmsClick = () => {
    setSmsChecked(!smsChecked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let Errors = {};
    if (!address?.length > 0) {
      Errors.address = 'Store Address is mandatory';
    }

    if (
      !branchName ||
      !isAlphanumericHyphenOnly(branchName) ||
      (branchName && branchName?.length >= 25)
    ) {
      if (branchName && branchName?.length >= 25) {
        Errors.branchName = 'Store name max 25 characters long';
      } else {
        Errors.branchName = 'Store name is mandatory or Invalid format';
      }
    }

    if (!ReferralValidNo.includes(referralNo)) {
      Errors.referralNo = 'Invalid Referral No';
    }

    if ((referralNo && isValidAptNo(referralNo)) || referralNo?.length >= 15) {
      if (referralNo.length >= 15) {
        Errors.referralNo = 'Referral No max 15 characters long';
      } else {
        Errors.referralNo = 'Invalid Referral Format No';
      }
    }
    if (!isFullName(firstName) || !firstName || firstName?.length >= 25) {
      if (firstName?.length >= 25) {
        Errors.firstName = 'First name max 10 characters long';
      } else {
        Errors.firstName = 'Invalid First name format';
      }
    }
    if (!isFullName(lastName) || !lastName || lastName?.length >= 25) {
      if (lastName?.length >= 25) {
        Errors.lastName = 'Last name max 10 characters long';
      } else {
        Errors.lastName = 'Invalid Last name format';
      }
    }

    if (!isValidEmail(email) || !email || (email && email?.length >= 50)) {
      if (email && email?.length >= 50) {
        Errors.email = 'Email can be max 50 characters long';
      } else {
        Errors.email = 'Invaild email format';
      }
    }
    if (!isMobileNo(phoneNo) || !phoneNo) {
      Errors.phoneNo = 'Invaild Mobile phone number format';
    }
    if (!isPassword(password) || !password || password?.length >= 50) {
      if (password?.length >= 50) {
        Errors.password = 'Password can be max 50 characters long';
      } else {
        Errors.password =
          'Password should be 8 characters long, with atleast one uppercase letter, one lowercase letter, one number and one special character';
      }
    }
    if (password !== reTypePassword) {
      Errors.reTypePassword = 'Invaild reTypePassword format';
    }

    if (bizCategory === 'Select') {
      Errors.bizCategory = 'Invaild biz category';
    }

    if (!address?.toLowerCase().includes(ValidServingCity?.toLowerCase())) {
      Errors.address = 'We are not currently serving the selected city';
    }

    if (Object.keys(Errors)?.length > 0) {
      setValidationErrors(Errors);
    } else {
      setValidationErrors(null);
      const payload = {
        email: email,
        kitchenName: branchName,
        phone_no: phoneNo,
        account_type: bizType,
        restaurant_category: bizCategory,
        password: password,
        retype_password: reTypePassword,
        firstName: firstName,
        lastName: lastName,
        address: address,
        operation_start_time: operation_start_time,
        operation_end_time: operation_end_time,
        referral_no: referralNo,
        cuisine: cuisineType,
        package_plan: selectedPricePLan,
        timeZone: timeZone,
        managing_branch_name: regionalBranchName,
        ...nativeNotificationFields,
      };
      await onSignUp(payload);
    }
  };

  if (success === false && message === API_NETWORK_ERROR) {
    return <Error404 />;
  }

  if (openOTPcomponent && !isOtpVerified) {
    return <PhoneVerifyOtp isSignup={true} {...{ kitchen_name: branchName, phone_no: phoneNo }} />;
  }

  if (isOtpVerified) {
    return <ThankYouSignup />;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          width: '410PX',
          height: 'auto',
          borderRadius: '10px',
          boxShadow: 'rgb(189, 189, 189) 0px 3px 6px 0px',
          padding: '40px',
          border: '4px solid rgb(255, 123, 41)',
        }}
      >
        {(backendValidationError || notServingLocation) && (
          <Alert
            id='alert-box'
            severity='error'
            sx={{
              width: '385px',
              border: 'solid 1px #E74C3C',
              marginBottom: '5px',
              backgroundColor: '#FDEDEB',
              color: 'red',
            }}
          >
            <AlertTitle sx={{ fontSize: '14px', fontWeight: 600 }}>Error</AlertTitle>

            {notServingLocation && <div>{responseErrorMapping(message)}</div>}
            {backendValidationError && (
              <ul>
                {data?.data?.errors?.map((el, index) => (
                  <li style={{ fontSize: '12px' }} key={index}>
                    {responseErrorMapping(el.ErrorMessage)}
                  </li>
                ))}
              </ul>
            )}
          </Alert>
        )}

        {validationErrors !== null && (
          <Alert
            severity='error'
            sx={{
              width: '375px',
              border: 'solid 1px #E74C3C',
              backgroundColor: '#FDEDEB',
              color: 'red',
            }}
          >
            <AlertTitle sx={{ fontSize: '14px', fontWeight: 600 }}>Error</AlertTitle>

            <ul>
              {Object.keys(validationErrors).map((el, index) => (
                <li style={{ fontSize: '12px' }} key={index}>
                  {' '}
                  <strong>{validationErrors[el]}</strong>
                </li>
              ))}
            </ul>
          </Alert>
        )}

        <div
          style={{
            marginBottom: '20px',
            color: '#3F3F6E',
            fontSize: isIpad ? '20px' : '30px',
            fontWeight: '700',
          }}
        >
          {' '}
          Signup
        </div>
        <GoogleAddressInput
          styleAutoComplete={{ width: '400px', margin: '10px 5px 5px 0px' }}
          error={
            validationErrors !== null &&
            validationErrors['address'] &&
            validationErrors['address'].length > 0
          }
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <InputBox
            type='text'
            label='First Name*'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='firstName'
            value={firstName}
            maxLength='10'
            error={
              validationErrors !== null &&
              validationErrors['firstName'] &&
              validationErrors['firstName'].length > 0
            }
            onChange={onChangeHandler('firstName')}
          />
          <InputBox
            type='text'
            label='Last Name'
            size='small'
            sx={{
              width: '195px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='lastName'
            value={lastName}
            maxLength='10'
            error={
              validationErrors !== null &&
              validationErrors['lastName'] &&
              validationErrors['lastName'].length > 0
            }
            onChange={onChangeHandler('lastName')}
          />
        </div>

        <InputBox
          type='text'
          label='Email'
          size='small'
          sx={{
            width: '400px',
            height: 'auto',
            margin: '10px 5px 5px 0px',
          }}
          name='email'
          value={email}
          maxLength='10'
          error={
            validationErrors !== null &&
            validationErrors['email'] &&
            validationErrors['email'].length > 0
          }
          onChange={onChangeHandler('email')}
        />
        <InputBox
          type='text'
          label='User Id'
          size='small'
          sx={{
            width: '400px',
            height: 'auto',
            margin: '10px 5px 5px 0px',
          }}
          name='branchName'
          value={branchName}
          maxLength='10'
          error={
            validationErrors !== null &&
            validationErrors['branchName'] &&
            validationErrors['branchName'].length > 0
          }
          onChange={onChangeHandler('branchName')}
        />

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <InputBox
            type='number'
            label='Mobile phone number'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='phoneNo'
            value={phoneNo}
            maxLength='10'
            error={
              validationErrors !== null &&
              validationErrors['phoneNo'] &&
              validationErrors['phoneNo'].length > 0
            }
            onChange={onChangeHandler('phoneNo')}
          />
          {/* 
          <SelectBox
            sx={{
              width: '195px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            label='Biz Type'
            value={bizType}
            onChange={onChangeHandler('bizType')}
            options={bizOptions}
          /> */}

          <SelectBox
            sx={{
              width: '195px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            label='Biz Category'
            value={bizCategory}
            onChange={onChangeHandler('bizCategory')}
            options={bizRestaurantCategory}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <InputBox
            type='password'
            label='Password'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='password'
            value={password}
            maxLength='50'
            error={
              validationErrors !== null &&
              validationErrors['password'] &&
              validationErrors['password'].length > 0
            }
            onChange={onChangeHandler('password')}
          />
          <InputBox
            type='password'
            label='Retype Password'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='reTypePassword'
            value={reTypePassword}
            maxLength='50'
            error={
              validationErrors !== null &&
              validationErrors['reTypePassword'] &&
              validationErrors['reTypePassword'].length > 0
            }
            onChange={onChangeHandler('reTypePassword')}
          />
        </div>
        {/* <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                }}>
                    <TimePickerInput
                        name='operation_start_time'
                        id='operation_start_time'
                        label='Start Time'
                        disabled={false}
                        disableFuture={false}
                        size='small'
                        sx={{
                            minWidth: '100px !important',
                            width: "200px",
                            height: "auto",
                            margin: "10px 5px 5px 0px",
                        }}
                        value={startTime}
                        variant='outlined'
                        onChange={onChangeHandler("operation_start_time")} />

                    <TimePickerInput
                        name='operation_end_time'
                        label='End Time'
                        disabled={false}
                        disableFuture={false}
                        id='operation_end_time'
                        size='small'
                        sx={{
                            minWidth: '100px !important',
                            width: "200px",
                            height: "auto",
                            margin: "10px 5px 5px 0px",
                        }}
                        value={endTime}
                        variant='outlined'
                        onChange={onChangeHandler("operation_end_time")} />

                </div> */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <SelectBox
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            label='Cuisine Type'
            value={cuisineType}
            onChange={onChangeHandler('cuisineType')}
            options={cuisineOptions}
          />

          <InputBox
            type='text'
            label='Package plan'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='packagePlan'
            value={selectedPricePLan}
            maxLength='10'
            error={
              validationErrors !== null &&
              validationErrors['packagePlan'] &&
              validationErrors['packagePlan'].length > 0
            }
            onChange={onChangeHandler('packagePlan')}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <InputBox
            type='text'
            label='Referral No'
            size='small'
            sx={{
              width: '200px',
              height: 'auto',
              margin: '10px 5px 5px 0px',
            }}
            name='referralNo'
            value={referralNo}
            maxLength='10'
            error={
              validationErrors !== null &&
              validationErrors['referralNo'] &&
              validationErrors['referralNo'].length > 0
            }
            onChange={onChangeHandler('referralNo')}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: '5px',
          }}
        >
          <AtomicCheckbox
            disabled={false}
            checked={checked}
            onChange={handleClick}
            sx={{
              padding: isMobile ? '0' : '0px',
              margin: isMobile ? 0 : '10px 5px 5px 0px',
              color: '#3F3F6E',
            }}
          />
          <div
            style={{
              marginTop: '8px',
              fontSize: '12px',
              fontFamily: 'Inter Regular',
              color: '#3F3F6E',
              textAlign: 'justify',
            }}
          >
            By clicking "Checkbox", you agree to{' '}
            <span style={{ fontSize: '12px', fontFamily: 'Inter Bold' }}>SingleCombo </span>{' '}
            Merchant &nbsp;
            <span
              onClick={RedirectMerchantTerms}
              style={{
                fontFamily: 'Inter SemiBold',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Merchant Terms and Conditions
            </span>{' '}
            and acknowledge you have read the{' '}
            <span
              onClick={RedirectToPrivacy}
              style={{
                fontFamily: 'Inter SemiBold',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Privacy Notice.
            </span>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <AtomicCheckbox
            disabled={false}
            checked={smsChecked}
            onChange={handleSmsClick}
            sx={{
              padding: isMobile ? '0' : '0px',
              margin: isMobile ? 0 : '10px 5px 5px 0px',
              color: '#3F3F6E',
            }}
          />
          <div
            style={{
              marginTop: '8px',
              fontSize: '12px',
              fontFamily: 'Inter Regular',
              color: '#3F3F6E',
              textAlign: 'justify',
            }}
          >
            {/* By checking this box, you agree to receive marketing text messages from{' '}
            <span style={{ fontSize: '12px', fontFamily: 'Inter Bold' }}>SingleCombo. </span>
            These may include promotions, special offers, and updates. Consent is not a condition of
            purchase. Message frequency may vary. Message and data rates may apply. Reply STOP to
            opt out anytime and HELP for help */}
            By checking this box, you agree to receive a one-time verification code via SMS to
            confirm your phone number for account authentication. Consent is not a condition of
            purchase. Message and data rates may apply. Reply STOP to opt out and HELP for help
          </div>
        </div>
        <AtomicButton
          label='Signup'
          handleSubmit={handleSubmit}
          style={{ backgroundColor: '#181436', width: '100%' }}
          loading={loading}
          disabled={!checked}
        />
      </div>
    </>
  );
};

export default Signup;
